import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import { APP_METADATA } from '../../config/constants';
import PageLayout from '../../components/PageLayout/PageLayout';
import SkillsGrid from '../../components/SkillsGrid/SkillsGrid';
import AwardsSection from '../../components/Awards/Awards';
import TestimonialsSection from '../../components/Testimonials/Testimonials';
// Styles are now centralized in src/styles/

const Home = () => {
  useSEO({
    title: 'Home',
    description: APP_METADATA.description,
    keywords: APP_METADATA.keywords,
  });

  return (
    <PageLayout className="home-page" title={null}>
      <header className="section-header text-center">
        <h1 className="section-header__title">Mahanoor Syed</h1>
        <h6 className="section-header__subtitle">
          Electronic and Information Engineering Graduate | Imperial College
          London | Founder of Tutortap Tuition
        </h6>
      </header>
      
      <SkillsGrid />
      
      <div className="layout-row">
        <section className="layout-row__item layout-row__item--small" aria-label="Awards section">
          <AwardsSection />
        </section>
        <section className="layout-row__item layout-row__item--large" aria-label="Testimonials section">
          <TestimonialsSection />
        </section>
      </div>
    </PageLayout>
  );
};

export default Home;

